import React, { useState } from 'react';
import {
	Box,
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Text,
	useDisclosure,
} from '@chakra-ui/react';
import { SketchPicker } from 'react-color';
import { ChevronLeftIcon, CloseIcon } from '@chakra-ui/icons';
import { useUserEditorProvider } from '../../../providers/UserEditor/userEditorProvider';
import { useUserProvider } from 'src/providers/User/userProvider';
import { t } from 'i18next';
import { isLauncher } from '../../../utils/launcher';
import { Link } from 'react-router-dom';
import { Color } from '../../../theme/color';

export const EditColorThere = () => {
	const { isOpen, onOpen, onClose } = useDisclosure();

	const { data: userData } = useUserProvider();
	const userEditorData = useUserEditorProvider();

	const [color, setColor] = useState(userData.color);
	const [isLoading, setIsLoading] = useState(false);

	const saveColor = () => {
		userEditorData.setColor(color);
		onClose();
	};

	const sketchStyles: any = {
		picker: {
			background: 'transparent',
		},
	};

	return (
		<>
			<Modal
				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent
					bg={Color.BACKGROUND_LIGHT}
					border={`1px solid ${Color.BACKGROUND_TERTIARY}`}
					m="0 20px"
					color="black"
					alignSelf="center"
				>
					<ModalHeader
						display="flex"
						justifyContent="space-between"
						alignItems="center"
						color="white"
					>
						<Text
							fontWeight="600"
							fontSize="20px"
						>
							{t('user.colorSettings').toString()}
						</Text>
						<Flex
							cursor="pointer"
							justifyContent="center"
							alignItems="center"
							maxW="20px"
							maxH="20px"
							onClick={onClose}
							border="1px solid white"
							borderRadius="50%"
							p="5px"
						>
							<CloseIcon
								w="7px"
								h="7px"
							/>
						</Flex>
					</ModalHeader>
					<ModalBody
						alignItems="center"
						css={{
							label: {
								color: 'white !important',
								fontWeight: '600',
							},
							'.flexbox-fix': {
								border: 'none !important',
							},
						}}
					>
						<SketchPicker
							styles={sketchStyles}
							width="auto"
							color={color}
							onChangeComplete={value => setColor(value.hex)}
						/>
						<Flex
							m="20px 0"
							justifyContent="flex-end"
						>
							<Button
								isLoading={isLoading}
								disabled={isLoading}
								onClick={saveColor}
							>
								{t('default.close').toString()}
							</Button>
						</Flex>
					</ModalBody>
				</ModalContent>
			</Modal>
			{isLauncher() && (
				<Flex
					align="center"
					lineHeight="18px"
					mb="4"
					zIndex={5}
				>
					<ChevronLeftIcon />
					<Link to="/">
						<Text fontSize="12px">Go back</Text>
					</Link>
				</Flex>
			)}
			<Flex
				zIndex={5}
				cursor="pointer"
				onClick={onOpen}
				borderRadius="8px"
				alignItems="center"
				p="6px 11px"
				gridGap="8px"
				fontSize="10px"
				fontWeight="700"
				mb="16px"
				border={`1px solid ${userEditorData.color ?? userData.color}`}
				userSelect="none"
			>
				{t('user.themeColor').toString()}
				<Box
					w="8px"
					h="8px"
					bg={userEditorData.color ?? userData.color}
					borderRadius="50%"
				/>
			</Flex>
		</>
	);
};
